import React, { Component } from 'react';
import {DisplayCard, CardLeft, Image, LikeButton, CardCenter, Title, Tips } from '../styles/card_styles';
import {Divider, CardRight, ReviewStat, RevStatText, Reviews, LiRev, MissingText, MissingImg, CenterContent} from '../styles/card_styles';
import {CSSTransition} from 'react-transition-group';
// import '../styles/transitional_query.css';

export default class ResultCard extends Component {
  constructor(props) {
    super(props);
    this.isFavorites = this.isFavorites.bind(this)
    const favs = this.isFavorites(props)
    this.state = {
      query_terms: props.query_terms,
      nav_selection: props.nav_selection,
      business_type: props.data.business_type,
      id: props.data.entity_id,
      latitude: props.data.latitude,
      longitude: props.data.longitude,
      name: props.data.name,
      summary1: props.data.summary1,
      summary2: props.data.summary2,
      heart_selected: favs,
      hover_active: props.hover_active,
      trigger_fadein: props.trigger_fadein,
      query_hovered: props.query_hovered,
      image: props.image
    }
    this.onHeartClick = this.onHeartClick.bind(this)
  }

  UNSAFE_componentWillReceiveProps(props){
    const fav_status = this.isFavorites(this.props)

    this.setState(
    { heart_selected: fav_status,
      query_hovered: props.query_hovered,
      hover_active: props.hover_active,
      trigger_fadein: false
    })
  }

  isFavorites(args){
    const favs = args.favorites
    const id = args.data.entity_id
    for(var i = 0; i < favs.length; i++){
      if(favs[i].entity_id === id){
        return true
      }
    }
    return false
  }

  onHeartClick(){
    const entity_id = this.state.id
    const name = this.state.name
    const lat = this.state.latitude
    const lng = this.state.longitude
    const biz_type = this.state.business_type
    const image = this.state.image
    const summary1 = this.state.summary1
    this.props.updateFavorites(entity_id, name, lat, lng, biz_type, image, summary1)
  }

  toggleHeartImage(){
    const heartSelected = require('../images/heart-red.png');
    const heartDeselected = require('../images/heart-empty.png');
    const heartImage = this.state.heart_selected ? heartSelected : heartDeselected
    return heartImage
  }

  reviewContents(hover){
    const reviews = this.state.summary2
    var query_based_reviews =[];
    var review_elements = [];
    if(reviews[hover]){
      query_based_reviews = reviews[hover];
      Object.keys(query_based_reviews).forEach(function(k, i){
        var phrase = query_based_reviews[k].phrase;
        var trimmed_phrase = phrase.trim()
        review_elements.push(<LiRev key= {i}> "{trimmed_phrase}" </LiRev>)
      }, this);
    }

    if(hover === undefined || hover === ""){
      const no_hover_text = "Hover over your queries to view related review phrases here."
      const no_rev_img = require("../images/no-reviews-illustration.svg")
      return(
        <CardRight>
          <MissingImg src={no_rev_img} alt="No reviews to display"/>
          <MissingText>{ no_hover_text }</MissingText>
        </CardRight>
      )
    }
    if(reviews.length === 0){
      const missing_text = "We found no reviews for this filter. Try hovering on others or adding more."
      const no_rev_img = require("../images/no-reviews-illustration.svg")
      return (
        <CardRight>
          <MissingImg src={no_rev_img} alt="No reviews to display"/>
          <MissingText>{ missing_text }</MissingText>
        </CardRight>
      )
    }
    if(this.state.trigger_fadein === true){
      var key = Math.round(Math.random() * 10)
      return (
        <CSSTransition in={true} timeout={3500} classNames='query' appear key={key}>
          <CardRight>
              <ReviewStat>
                <RevStatText>
                "{hover}" related reviews
                </RevStatText>
              </ReviewStat>
            <Reviews> {review_elements} </Reviews>
          </CardRight>
        </CSSTransition>
      )
   } else {
      return (
          <CardRight>
            <ReviewStat hover_active= {this.state.hover_active}>
              <RevStatText>
              "{hover}" related reviews
              </RevStatText>
            </ReviewStat>
            <Reviews> {review_elements} </Reviews>
          </CardRight>
      )
    }
  }

  render(){
  const desc = this.props.data.summary1
  const each_desc = this.props.renderRevSummary(desc)
  const heartImage = this.toggleHeartImage();
  var image_alt = `location image, descriptor: ${this.props.data.entity_id}`

    return(
      <DisplayCard>
        <CardLeft>
          <Image src= {this.state.image} alt= {image_alt}/>
          <LikeButton onClick={ this.onHeartClick } ><img src={ heartImage } alt="heart"/></LikeButton>
        </CardLeft>
        <CardCenter>
          <CenterContent>
            <Title> { this.props.data.name } </Title>
            <Tips>
              { each_desc }
            </Tips>
          </CenterContent>
        </CardCenter>
        <Divider />
        {this.reviewContents(this.state.query_hovered)}
      </DisplayCard>
    );
  }
}
